export default [
  {
    id: 1,
    text: 'Ajustar preço',
    value: 'FIX_PRICE',
  },
  {
    id: 2,
    text: 'Copiar dias',
    value: 'COPY_DAYS',
  },
  {
    id: 3,
    text: 'Copiar método inteiro',
    value: 'CONSUME',
  },
  {
    id: 4,
    text: 'Ajustar dias',
    value: 'FIX_DAYS',
  },
  {
    id: 5,
    text: 'Copiar preço',
    value: 'COPY_PRICE',
  },
  {
    id: 6,
    text: 'Acrescentar dias',
    value: 'CHANGE_DAYS',
  },
  {
    id: 7,
    text: 'Acrescentar preço',
    value: 'CHANGE_PRICE',
  },
  {
    id: 8,
    text: 'Excluir caso houver',
    value: 'EXCLUDE_ME',
  },
];



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-quote/features/quoting-return/enum/EnumConditionalAction.js